export default [
  {
    path: "/faq",
    name: "FAQ",
    component: () => import("./views/FAQView.vue"),
    props: true
  }
];
